import styled from 'styled-components';

export const TypeOfDataImportNameInputStyle = {
  Container: styled.div``,
};
